
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class EmailTemplateVariablesGrid extends Serenity.EntityGrid<EmailTemplateVariablesRow, any> {
        protected getColumnsKey() { return EmailTemplateVariablesColumns.columnsKey; }
        protected getDialogType() { return EmailTemplateVariablesDialog; }
        protected getIdProperty() { return EmailTemplateVariablesRow.idProperty; }
        protected getInsertPermission() { return EmailTemplateVariablesRow.insertPermission; }
        protected getLocalTextPrefix() { return EmailTemplateVariablesRow.localTextPrefix; }
        protected getService() { return EmailTemplateVariablesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}